import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ForgotPasswordRoutingModule } from './forgot-password-routing.module';
import { ForgotPasswordComponent } from './page/forgot-password/forgot-password.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { CoreModule, LoaderInterceptor, LoaderService } from 'src/app/core/core.module';
import { environment } from 'src/environments/environment';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ChangePasswordComponent } from './page/change-password/change-password.component';
import { ForgotPasswordChallengeComponent } from './page/forgot-password-challenge/forgot-password-challenge.component';
import { ForgotPasswordMfaComponent } from './page/forgot-password-mfa/forgot-password-mfa.component';
import { ForgotPasswordVerifyComponent } from './page/forgot-password-verify/forgot-password-verify.component';
import { NgOtpInputModule } from 'ng-otp-input';


@NgModule({
  declarations: [
    ForgotPasswordComponent,
    ChangePasswordComponent,
    ForgotPasswordMfaComponent,
    ForgotPasswordChallengeComponent,
    ForgotPasswordVerifyComponent
  ],
  imports: [
    CommonModule,
    ForgotPasswordRoutingModule,
    SharedModule,
    NgOtpInputModule,
    CoreModule.forRoot(environment)
  ],
  providers: [
    LoaderService,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }
  ]
})
export class ForgotPasswordModule { }
